// ----------------------------------------------------------------------

const ROOTS = {
  AUTH: '/auth',
  DASHBOARD: '/dashboard',
};

// ----------------------------------------------------------------------

export const paths = {
  minimalUI: 'https://mui.com/store/items/minimal-dashboard/',
  // AUTH
  auth: {
    jwt: {
      login: `${ROOTS.AUTH}/jwt/login`,
      register: `${ROOTS.AUTH}/jwt/register`,
    },
  },
  // DASHBOARD
  dashboard: {
    root: (shopid) => `${ROOTS.DASHBOARD}/${shopid}`,
    one: (shopid) => `${ROOTS.DASHBOARD}/${shopid}/one`,
    two: (shopid) => `${ROOTS.DASHBOARD}/${shopid}/two`,
    three: (shopid) => `${ROOTS.DASHBOARD}/${shopid}/three`,
    theme: (shopid) => `${ROOTS.DASHBOARD}/${shopid}/theme`,
    group: {
      root: (shopid) => `${ROOTS.DASHBOARD}/${shopid}/group`,
      five: (shopid) => `${ROOTS.DASHBOARD}/${shopid}/group/five`,
      six: (shopid) => `${ROOTS.DASHBOARD}/${shopid}/group/six`,
    },
    companies: {
      root: `${ROOTS.DASHBOARD}/shops`,
      new: `${ROOTS.DASHBOARD}/shops/new`,
      edit: (id) => `${ROOTS.DASHBOARD}/shops/${id}/edit`,
      manager: (id) => `${ROOTS.DASHBOARD}/shops/${id}/manager`,
    },
    notify: {
      shop: (id) => `${ROOTS.DASHBOARD}/shops/${id}/notify`,
    },
    payment: {
      shop: (id) => `${ROOTS.DASHBOARD}/shops/${id}/payment`,
    },
    services: {
      shop: (id) => `${ROOTS.DASHBOARD}/shops/${id}/services`,
    },
    employees: {
      shop: (id) => `${ROOTS.DASHBOARD}/shops/${id}/employees`,
    },
    historybooking: {
      list: (id) => `${ROOTS.DASHBOARD}/shops/${id}/historybooking`,
    },
    user: {
      list: (id) => `${ROOTS.DASHBOARD}/shops/${id}/user`,
    },
    referrals: {
      root: `${ROOTS.DASHBOARD}/referrals`,
    },
    cases: {
      root: `${ROOTS.DASHBOARD}/cases`,
    },
    chat: {
      root: (id) => `${ROOTS.DASHBOARD}/shops/${id}/chat`,
      new: (id) => `${ROOTS.DASHBOARD}/shops/${id}/chat/new`,
      view: (id, conversationKey) => `${ROOTS.DASHBOARD}/shops/${id}/chat/${conversationKey}`,
    },
  },
};

export const PATH_DASHBOARD = paths.dashboard;
